var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPlayCircleHollow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14359 9.0005C3.14359 5.58595 5.91163 2.8179 9.32619 2.8179C12.7407 2.8179 15.5088 5.58595 15.5088 9.0005C15.5088 12.4151 12.7407 15.1831 9.32619 15.1831C5.91163 15.1831 3.14359 12.4151 3.14359 9.0005ZM9.32619 1.68311C5.2849 1.68311 2.00879 4.95922 2.00879 9.0005C2.00879 13.0418 5.2849 16.3179 9.32619 16.3179C13.3675 16.3179 16.6436 13.0418 16.6436 9.0005C16.6436 4.95922 13.3675 1.68311 9.32619 1.68311ZM12.2823 9.78398C12.8408 9.43399 12.8408 8.56707 12.2823 8.21707L8.34594 5.75044C7.78306 5.39772 7.07617 5.83388 7.07617 6.5339V11.4672C7.07617 12.1672 7.78306 12.6033 8.34594 12.2506L12.2823 9.78398Z",
    fill: "#D1D2D3"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayCircleHollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-circle-hollow.a337cf9ee65f0260a3c38f638d5f59b9.svg";